import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06cfd4e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-campaign-cocacola-season-5"
}
const _hoisted_2 = { class: "loop-scroll-title" }
const _hoisted_3 = { class: "footer-btn-group" }

import PageMain from './components/page-main.vue';
import PageMission from './components/page-mission.vue';
import LoopScrollTitle from './components/loop-scroll-title.vue';
import PageDate from './components/page-date.vue';
import PageMethod from './components/page-method.vue';
import PageFaq from './components/page-faq.vue';
import Navbar from './components/navbar.vue';
import CheckPopups, { type CheckExpose } from './components/popups/check.vue';
import QuizPoupups, { type QuizeExpose } from './components/popups/quiz.vue';
import ParticipatePopups, { type ParticipateExpose } from './components/popups/participate.vue';
import CollectPopups, { type CollectExpose } from './components/popups/collect.vue';
import { provide, ref, inject, nextTick, toRef, reactive, computed, Ref } from 'vue';
import 'swiper/css';
import 'swiper/css/pagination';
import _ from 'lodash';
import { IProgram } from '@/types/program';
import PopupError from './components/popups/popup-error.vue';
import { getImages } from './static';
import { useElementVisibility, useScroll } from '@vueuse/core';
import { useRoute, useRouter } from 'vue-router';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import NoticePopup from './components/popups/notice.vue';

interface IProps {
  program: IProgram;
}interface MenuType {
  name: string;
  key?: 'main' | 'mission' | 'date' | 'method' | 'faq';
  pageRef?: Ref<HTMLDivElement | undefined>;
  anchor?: string;
  onClick?: () => Promise<void>;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

const props = __props as { program: IProgram }

dayjs.extend(isBetween);

;



provide('program', toRef(props, 'program'));

const navbarIsVisible = ref(true);

const refreshPageData = inject<Function>('refreshPageData') || _.noop;

const popupVisible = reactive({
  error: false,
});

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    _.forEach(popupVisible, (val, key) => {
      if (val) {
        popupVisible[key] = false;
      }
    });
  }
}

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

const errMsg = ref('');
const checkPopupsRef = ref<CheckExpose>();
const quizPopupsRef = ref<QuizeExpose>();
const participatePopupsRef = ref<ParticipateExpose>();
async function participate() {
  if (!props.program?.show_participate_btn) {
    const rounds = props.program.program_rounds;
    if (rounds?.length && rounds.length >= 2) {
      const $now = dayjs();
      // 如果在报名活动期内
      if ($now.isBetween(rounds[0].participate_started_at, _.last(rounds)?.participate_ended_at, 'millisecond', '[]')) {
        const currentParticipateRound = rounds.find(item => $now.isBetween(item.participate_started_at, item.participate_ended_at, 'millisecond', '[]'));
        // 当前时间不在任何一轮
        if (!currentParticipateRound) {
          window.open('https://forms.gle/LWNN4VG6b5HMdcFH8', '_blank');
          return;
        }
      }
    }
  }

  const valid = await checkPopupsRef.value?.start();
  if (valid) {
    await refreshPageData();
    await nextTick();
    const { show_participate_btn, participate_btn_msg } = props.program || {};
    if (!show_participate_btn) {
      errMsg.value = participate_btn_msg || '';
      showPopup('error');
      return;
    }
    quizPopupsRef.value?.start();
  }
}
provide('participate', participate);

const collectPopupsRef = ref<CollectExpose>();
async function collect() {
  const valid = await checkPopupsRef.value?.start();
  if (valid) {
    await refreshPageData();
    await nextTick();
    const { show_collection_btn, collection_count = 0, collection_challenge = 0, collection_btn_msg } = props.program || {};
    if (show_collection_btn) {
      // 超过了提交次数
      if (collection_count >= collection_challenge) {
        errMsg.value = `수령하신 제로 웨이스트 박스
  모두 수거 신청 완료되었습니다.`;
        showPopup('error');
        return;
      }
      collectPopupsRef.value?.start();
      return;
    }
    errMsg.value = collection_btn_msg || '';
    showPopup('error');
  }
}
provide('collect', collect);

function onQuizeDone() {
  participatePopupsRef.value?.start();
}

function checkWebPSupport(): Promise<boolean> {
  return new Promise((resolve) => {
    const image = new Image();
    image.addEventListener('error', () => resolve(false));
    image.addEventListener('load', () => resolve(image.width > 0 && image.height > 0));
    image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
  });
}

const supportWebp = ref<boolean | undefined>();
const pageInited = ref(false);
checkWebPSupport()
  .then(support => supportWebp.value = support)
  .catch(() => supportWebp.value = false)
  .finally(() => nextTick(() => {
    pageInited.value = true;
    setTimeout(scrollToAnchorPosition, 300);
  }));

const s5Images = computed(() => getImages(supportWebp.value));
provide('images', s5Images);

let isScrollingProgrammatically = false;
const activeMenuIndex = ref(0);

const pageMainRef = ref<HTMLDivElement>();
const pageMissionRef = ref<HTMLDivElement>();
const pageDateRef = ref<HTMLDivElement>();
const pageMethodRef = ref<HTMLDivElement>();
const pageFaqRef = ref<HTMLDivElement>();

const menus = computed<Array<MenuType>>(() => {
  return [
    {
      name: '홈',
      key: 'main',
      pageRef: pageMainRef,
      anchor: '#page-main',
    },
    {
      name: '미션 설명',
      key: 'mission',
      pageRef: pageMissionRef,
      anchor: '#page-mission',
    },
    {
      name: '미션 일정',
      key: 'date',
      pageRef: pageDateRef,
      anchor: '#page-date',
    },
    {
      name: '수거 가이드',
      key: 'method',
      pageRef: pageMethodRef,
      anchor: '#page-method',
    },
    {
      name: 'FAQ',
      key: 'faq',
      pageRef: pageFaqRef,
      anchor: '#page-faq',
    },
    {
      // 参加
      name: '참가 지원',
      onClick: participate,
      disabled: !props.program?.show_participate_btn,
    },
    {
      // 回收
      name: '수거 신청',
      onClick: collect,
      disabled: !props.program?.show_collection_btn,
    }
  ];
});

const pageVisibles = menus.value.filter(item => item.pageRef).map(item => useElementVisibility(item.pageRef));
const { directions } = useScroll(window, {
  onScroll() {
    if (isScrollingProgrammatically) {
      return;
    }
    if (directions.bottom) {
      activeMenuIndex.value = _.findLastIndex(pageVisibles, item => item.value);
    }
    if (directions.top) {
      activeMenuIndex.value = _.findIndex(pageVisibles, item => item.value);
    }
  },
  onStop() {
    isScrollingProgrammatically = false;
  },
});

function navToPage(item: typeof menus.value[number]) {
  if (item.onClick) {
    item.onClick();
    return;
  }
  if (item.pageRef) {
    isScrollingProgrammatically = true;
    item.pageRef?.value?.scrollIntoView({ block: 'start' });
    activeMenuIndex.value = menus.value.findIndex(i => i.name === item.name);
  }
}

function navToPageByKey(key: MenuType['key']) {
  const item = menus.value.find(item => item.key === key);
  if (item) {
    navToPage(item);
  }
}
provide('navToPageByKey', navToPageByKey);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const router = useRouter();
function onMenuItemClick(item: typeof menus.value[number]) {
  navToPage(item);
  // 客户应该是想要点按钮不加锚点，自己输入链接带上锚点
  // if (item.anchor) {
  //   // 用锚点在有的手机有些奇怪的问题
  //   router.push({ hash: item.anchor });
  // }
}

const route = useRoute();
function scrollToAnchorPosition() {
  const key = route.hash.split('#page-').pop();
  if (key) {
    navToPageByKey(key as any);
  }
}

const showNoticePopup = ref(dayjs().isBefore('2024-07-31T20:00:00.000+09:00', 'millisecond'));

return (_ctx: any,_cache: any) => {
  return (pageInited.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "navbar-fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(Navbar, {
              sticky: "",
              "active-menu-index": activeMenuIndex.value,
              menus: _unref(menus),
              onMenuClick: onMenuItemClick
            }, null, 8, ["active-menu-index", "menus"]), [
              [_vShow, !navbarIsVisible.value]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          id: "page-main",
          ref_key: "pageMainRef",
          ref: pageMainRef
        }, [
          _createVNode(PageMain, {
            modelValue: navbarIsVisible.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((navbarIsVisible).value = $event)),
            "active-menu-index": activeMenuIndex.value,
            menus: _unref(menus),
            onMenuClick: onMenuItemClick
          }, null, 8, ["modelValue", "active-menu-index", "menus"])
        ], 512),
        _createElementVNode("div", {
          id: "page-mission",
          ref_key: "pageMissionRef",
          ref: pageMissionRef
        }, [
          _createVNode(PageMission)
        ], 512),
        _createElementVNode("div", {
          id: "page-date",
          ref_key: "pageDateRef",
          ref: pageDateRef
        }, [
          _createVNode(PageDate)
        ], 512),
        _createElementVNode("div", {
          id: "page-method",
          ref_key: "pageMethodRef",
          ref: pageMethodRef
        }, [
          _createVNode(PageMethod)
        ], 512),
        _createElementVNode("div", {
          id: "page-faq",
          ref_key: "pageFaqRef",
          ref: pageFaqRef
        }, [
          _createVNode(PageFaq)
        ], 512),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LoopScrollTitle)
        ]),
        _createVNode(CheckPopups, {
          ref_key: "checkPopupsRef",
          ref: checkPopupsRef
        }, null, 512),
        _createVNode(QuizPoupups, {
          ref_key: "quizPopupsRef",
          ref: quizPopupsRef,
          onSuccess: onQuizeDone
        }, null, 512),
        _createVNode(ParticipatePopups, {
          ref_key: "participatePopupsRef",
          ref: participatePopupsRef
        }, null, 512),
        _createVNode(CollectPopups, {
          ref_key: "collectPopupsRef",
          ref: collectPopupsRef
        }, null, 512),
        _createVNode(PopupError, {
          modelValue: _unref(popupVisible).error,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).error) = $event)),
          title: errMsg.value
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "footer-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (hidePopup()))
              }, " 확인했어요 ")
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(NoticePopup, {
          modelValue: showNoticePopup.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showNoticePopup).value = $event))
        }, null, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})